/**
 * External dependencies
 */
import React from "react";
import { render } from "react-dom";

/**
 * Internal dependencies
 */
import App from "./app";

(function () {
  let isInitialized = false;

  window.addEventListener("DOMContentLoaded", () => {
    if (!isInitialized) {
      isInitialized = true;
      init();
    }
  });

  const init = () => {
    const els = document.querySelectorAll(".em-block-story-feed");
    els.forEach((el) => {
      const { perPage, texts } = el.dataset || {};

      render(
        <App
          perPage={perPage ? parseInt(perPage) : 99}
          texts={texts ? JSON.parse(texts) : {}}
        />,
        el
      );
    });
  };
})();
